import { getToken } from "../../../API/VolumesAPI";

// The existing endpoints the normal plan screens use (backend main.py). Errors are thrown so the screen can show them.
const call = async (method, path, body, failMessage) => {
  const response = await fetch(path, {
    method,
    headers: { "Content-Type": "application/json", Authorization: "Bearer " + getToken() },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!response.ok) {
    let detail = "";
    try {
      detail = JSON.stringify((await response.json()).detail || "");
    } catch (e) {
      /* no body */
    }
    throw new Error(`${failMessage} (${response.status}) ${detail}`.trim());
  }
  return response.json();
};

const HybridPlanAPI = {
  getFarmers: () => call("GET", "/api/get_farmers", undefined, "Kon nie die produsente laai nie"),
  getCrops: () => call("GET", "/api/get_all_crops/", undefined, "Kon nie die gewasse laai nie"),
  createPlanting: (farmerId, body) => call("POST", "/api/create_planting_details/" + farmerId, body, "Kon nie die aanplanting skep nie"),
  getPlantings: (farmerId) => call("GET", "/api/all_planting_details/" + farmerId, undefined, "Kon nie die plantings laai nie"),
  getChoices: () => call("GET", "/api/all_choices/", undefined, "Kon nie die produk-keuses laai nie"),
  getPeriods: () => call("GET", "/api/get_periods_per_crop", undefined, "Kon nie die periodes laai nie"),
  createPlan: (plan) => call("POST", "/api/create_plan", plan, "Kon nie die program skep nie"),
  createPlanProduct: (body) => call("POST", "/api/create_plan_product", body, "Kon nie 'n produk by die program voeg nie"),
  getOrderProducts: (planId) => call("GET", "/api/get_order_products_by_plan_id/" + planId, undefined, "Kon nie die bestelprodukte laai nie"),
  setPacks: (orderProductId, packageKey, qty) =>
    call("POST", `/api/update_product_packages/${orderProductId}/${packageKey}/${qty}`, undefined, "Kon nie die bokse opdateer nie"),
};

export default HybridPlanAPI;
